import PropTypes from 'prop-types';

import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { useTransl } from 'shared/lib/i18n';

import { toSentenceCase } from '../../../utils';

import DropDownMenu from '../../DropDownMenu';

const ApprovalStatusComponent = ({
  id,
  approvalStatus,
  isExport,
  onUpdate,
  onRemove,
}) => {
  const { t } = useTransl();
  const theme = useTheme();

  if (!approvalStatus) return t('common.NA');
  const status = toSentenceCase(approvalStatus);

  if (isExport) return status;

  const colors = {
    grey: theme.palette.grey[400],
    secondary: theme.palette.secondary.main,
    success: theme.palette.success.main,
  };

  const isPending = approvalStatus === 'pending';
  const isApproved = approvalStatus === 'approved';
  const isAutoApproval = approvalStatus === 'auto';
  const isDeclined = approvalStatus === 'declined';

  const color = isPending
    ? colors.grey
    : isApproved || isAutoApproval
    ? colors.success
    : colors.secondary;

  const title = (
    <Typography color={theme.palette.common.white}>{status}</Typography>
  );

  const approvalStatusOptions = [
    {
      label: t('status.pending'),
      onClick: () => onUpdate(id, { status: 'pending' }),
      color: colors.grey,
      show: !isPending && !isAutoApproval,
    },
    {
      label: t('actions.approve'),
      onClick: () => onUpdate(id, { status: 'approved' }),
      color: colors.success,
      show: !isApproved && !isAutoApproval,
    },
    {
      label: t('status.decline'),
      onClick: () => onUpdate(id, { status: 'declined' }),
      color: colors.secondary,
      show: !isDeclined && !isAutoApproval,
    },
    {
      label: t('actions.delete'),
      onClick: () => onRemove(id),
      color: colors.secondary,
      show: isAutoApproval,
    },
  ];

  return (
    <DropDownMenu
      title={title}
      items={approvalStatusOptions}
      color={color}
      isButton
    />
  );
};

ApprovalStatusComponent.propTypes = {
  id: PropTypes.number.isRequired,
  approvalStatus: PropTypes.string,
  isExport: PropTypes.bool,
  onUpdate: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
};

export default ApprovalStatusComponent;
